import axios from "../helpers/axioxInstance";
import URLS from "../constData/urls";

export const drmDailyRecordCancel = async ([userCode, details, controller]) => {
  const config = controller ? { signal: controller.signal } : {};
  const response = await axios.post(
    URLS.DRM_DAILY_RECORD_CANCEL,
    { userCode, details },
    config
  );

  if (response.status >= 400) {
    throw new Error(response.message);
  }

  return response;
};
